module.exports = {"610402001":"人民路街道","610402002":"西兰路街道","610402003":"吴家堡街道","610402004":"渭阳西路街道","610402005":"陈杨寨街道","610402006":"古渡街道","610402007":"沣东街道","610402008":"钓台街道","610402009":"马泉街道","610402010":"渭滨街道","610402011":"双照街道","610402012":"马庄街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610402.json
// module id = 2806
// module chunks = 0